import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AvaState, AVA_FEATURE_KEY, selectAllAva, selectAvaEntities, selectAvaFetched, selectAvaLatestUpdatedAt } from '../reducers/ava.reducer';

const selectState = createFeatureSelector<AvaState>(AVA_FEATURE_KEY);
export const getAvaDictionary = createSelector(selectState, selectAvaEntities);
export const getAvaLatestUpdatedAt = createSelector(selectState, selectAvaLatestUpdatedAt);
export const getAvaFetched = createSelector(selectState, selectAvaFetched);
export const getAvas = createSelector(selectState, selectAllAva);
export const getAvasActive = createSelector(getAvas, (activities) => activities);
export const getAvaById = (props: { id: number }) => createSelector(getAvaDictionary, (dictionary) => props.id && dictionary[props.id]);
